module.exports = __webpack_public_path__ + "media/assets/images/cba@2x-b4b619f9172f00447a4d0c7c99ce4fa1.png";